import AppError from './classes/AppError';
import LazyMonkeyInfiniteScroll from './LazyMonkeyInfiniteScroll';
import LazyMonkeyLoadMore from './LazyMonkeyLoadMore';
import Settings, { ISettingsType } from './Settings';

export default class LazyMonkeyFactory {
  public static factory(inputSettings: ISettingsType) {
    const settings = new Settings(inputSettings);
    if (settings.getSettings().loaderType === 'infinite') {
      return new LazyMonkeyInfiniteScroll(settings);
    }
    if (settings.getSettings().loaderType === 'loadMore') {
      return new LazyMonkeyLoadMore(settings);
    }
    throw new AppError('Unrecognized loaderType value');
  }
}
